import { useMemo } from 'react';

import { useFeatureLoyaltyRewardListCategories } from 'hooks/use-feature-loyalty-reward-list-categories';
import { useLoyaltyRewardsList } from 'hooks/use-loyalty-rewards-list';

import { NonNullableRewardCategory } from './types';

/**
 * Filters and returns a array of reward categories based on the `baseCategories` received from `useFeatureLoyaltyRewardListCategories`.
 * It filters out rewards that don't exist in both `sanityRewardsMap` and `engineRewardsMap`.
 */
export const useFilteredRewardCategories = () => {
  const { data: baseCategories } = useFeatureLoyaltyRewardListCategories();
  const { sanityRewardsMap, engineRewardsMap } = useLoyaltyRewardsList();
  const rewardCategories = useMemo(
    () =>
      baseCategories?.reduce((filteredCategories: NonNullableRewardCategory[], category) => {
        if (category?.rewards?.length && sanityRewardsMap) {
          const filteredRewards = category.rewards.filter(reward => {
            return (
              reward?._id &&
              sanityRewardsMap[reward._id] &&
              engineRewardsMap[reward?.loyaltyEngineId || '']
            );
          });
          if (filteredRewards.length) {
            filteredCategories.push({ ...category, rewards: filteredRewards || [] });
          }
        }
        return filteredCategories;
      }, []),
    [baseCategories, engineRewardsMap, sanityRewardsMap]
  );

  return rewardCategories ?? [];
};
